export const BRANDING = {
  companyName: "شرکت تجارتی توکل نورزی",
  companyNamePs: "شرکت تجارتی توکل نورزی",
  companyNameFa: "شرکت تجارتی توکل نورزی",
  companyNameEn: "Tawakal Noorzai Trading Company",
  appNameEn: "Tawakal Noorzai Inventory System",
  phonePrimary: "0776000248",
  phoneSecondary: "0700800817",
  phoneDisplay: "0776000248 - 0700800817",
  address: "آدرس: سرک کابل کندهار، ایستگاه مارکیت سرشیانه فابکه تیل صادرات",
  addressPs: "پته: سرک کابل کندهار، ایستگاه مارکیت سرشیانه فابکه تیل صادرات",
  addressFa: "آدرس: سرک کابل کندهار، ایستگاه مارکیت سرشیانه فابکه تیل صادرات",
  addressEn: "Address: Kabul-Kandahar Road, Istgah Market, Sarshyana, Oil Export Factory",
  shortAddress: "سرک کابل کندهار، ایستگاه مارکیت سرشیانه فابکه تیل صادرات",
  email: "wahidtajzoi737@gmail.com",
  poweredByEn: "Powered by Tawakal Noorzai Trading Company",
};
